import Vue from 'vue';
import Router from 'vue-router';
import Landing from '@/components/site/Landing';
import Legal from '@/components/site/Legal';
import Privacy from '@/components/site/Privacy';
import MIWorkflows from '@/components/site/MIWorkflows';
import NotFound from '@/components/common/NotFound';
import BloomWaitlist from '@/components/site/BloomWaitlist';

Vue.use(Router);

export default new Router({
   routes: [
      {
         path: '/',
         name: 'Landing',
         component: Landing
      },
      {
         path: '/legal',
         name: 'Legal',
         component: Legal
      },
      {
         path: '/privacy',
         name: 'Privacy',
         component: Privacy
      },
      {
         path: '/whitepapers/multi-intelligence-workflows',
         name: 'Multi-Intelligence Workflows',
         component: MIWorkflows
      },
      {
         path: '/bloom/waitlist',
         name: 'Bloom Waitlist',
         component: BloomWaitlist
      },
      {
         path: '*', 
         name: 'NotFound',
         component: NotFound
      }
   ],
   mode: 'history'
});



// WEBPACK FOOTER //
// ./src/router/index.js